import { render, staticRenderFns } from "./FilesSingleSection.vue?vue&type=template&id=b8f1ff76&"
import script from "./FilesSingleSection.vue?vue&type=script&lang=js&"
export * from "./FilesSingleSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports